import { getOrganisationKey } from "../../logic/OrganisationUtil";
import { getUrlForList, setHighlightedResultId } from "../../logic/ListUtil";

const emptyString = "";

const createOrganisationNameCell = ({ result, event, list }) => {
    const url = getUrlForList(
        event, 
        { ...list, classIds: undefined, organisationKey: getOrganisationKey(result.organisation), entryIds: undefined, tag: undefined }
    ).url;

    const div = document.createElement("div");
    div.className = "organisationName";

    if(result.organisation) {
        const name = result.organisation.name || emptyString;
        const a = document.createElement("a");
        a.setAttribute("href", url);
        a.addEventListener("click", () => setHighlightedResultId(result.resultId));
        const icon = document.createElement("span");
        icon.className = "organisation-icon";
        if(result.organisation.organisationExternalId) {
            icon.classList.add(`oi-${result.organisation.organisationExternalId}`);
        } 
        a.appendChild(icon);
        a.insertAdjacentText("beforeend", name);
        div.appendChild(a);
    }
    return div;
};

export default createOrganisationNameCell;
